const types = {
  FETCH_OPERATOR_BASIC_DETAILS_START: 'FETCH_OPERATOR_BASIC_DETAILS_START',
  FETCH_OPERATOR_BASIC_DETAILS_SUCCESS: 'FETCH_OPERATOR_BASIC_DETAILS_SUCCESS',
  FETCH_OPERATOR_BASIC_DETAILS_FAILURE: 'FETCH_OPERATOR_BASIC_DETAILS_FAILURE',
  INITIATE_OPERATOR_UNDERTAKING_START: 'INITIATE_OPERATOR_UNDERTAKING_START',
  INITIATE_OPERATOR_UNDERTAKING_SUCCESS: 'INITIATE_OPERATOR_UNDERTAKING_SUCCESS',
  INITIATE_OPERATOR_UNDERTAKING_FAILURE: 'INITIATE_OPERATOR_UNDERTAKING_FAILURE',
};

export default types;
